/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Modal,
  Label,
  Checkbox,
  Popup,
  Form,
  Icon,
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import { Scrollbars } from 'react-custom-scrollbars-2';
//import cx from 'classnames';
//import ClarLoader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import searchIcon from '../../images/common/search_icon.png';

class AddUserDefinedModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      userDefinedList: [],
      checkValue: [],
      searchKeyword: '',
      isCheckAll: false,
      errSearch: false,
      copied: false,
      tooltipWithKeyName: '',
      tooltipWithDetailValue: '',
    };
    this.handleCopy = this.handleCopy.bind(this);
    this.handleCheckAllChange = this.handleCheckAllChange.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleSearchKeyPress = this.handleSearchKeyPress.bind(this);
    this.handleSearchDefinedResultChange = this.handleSearchDefinedResultChange.bind(this);
    this.openTooltipWithKeyName = this.openTooltipWithKeyName.bind(this);
    this.closeTooltipWithKeyName = this.closeTooltipWithKeyName.bind(this);
    this.openTooltipWithDetailValue = this.openTooltipWithDetailValue.bind(this);
    this.closeTooltipWithDetailValue = this.closeTooltipWithDetailValue.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.setting_popup .table_type_3 .text', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { isOpenMUD, selectedUserDefinedList } = this.props;

    if (prevProps.isOpenMUD !== isOpenMUD) {
      this.setState({
        //isOpenMUD,
        isOpen: false,
        userDefinedList: [],
        checkValue: [],
        searchKeyword: '',
        isCheckAll: false,
        errSearch: false,
        copied: false,
        tooltipWithKeyName: '',
        tooltipWithDetailValue: ''
      }, () => {
        if (isOpenMUD) {
          const newData = [];
          selectedUserDefinedList.map((item) => {
            return newData.push(item.user_defined_id);
          });
          this.searchCustomerCompanyDefinedResults(newData);
        }
      });
    }
  }

  handleCopy(value) {
    navigator.clipboard.writeText(value).then(() => {
      this.setState({ copied: true }, () => {
        setTimeout(() => { return this.setState({ copied: false }); }, 2000);
      });
    }).catch((err) => { return console.error('Copy failed', err); });
  }

  handleSearchDefinedResultChange(e) {
    this.setState({
      searchKeyword: e.target.value,
    });
  }

  handleSearchKeyPress(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
              });
            }, 1500);
          }
        );
        return;
      }
      this.setState(
        {
          userDefinedList: [],
        },
        () => {
          this.searchCustomerCompanyDefinedResults();
        }
      );
    }
  }

  handleCheckChange(e, { value }) {
    this.setState((prevState) => {
      const { checkValue, userDefinedList } = prevState;

      const newValue = checkValue.includes(value)
        ? checkValue.filter((el) => { return el !== value; })
        : [...checkValue, value];

      const allSelected = userDefinedList.length > 0 && userDefinedList.every((item) => { return newValue.includes(item.user_defined_id); });

      return {
        checkValue: newValue,
        isCheckAll: allSelected,
      };
    });
  }

  handleCheckAllChange() {
    this.setState((prevState) => {
      const { isCheckAll, userDefinedList } = prevState;
      if (isCheckAll) {
        return {
          isCheckAll: false,
          checkValue: [],
        };
      }
      const newState = userDefinedList.map((item) => { return item.user_defined_id; });
      const unique = [...new Set(newState)];
      return {
        isCheckAll: true,
        checkValue: unique,
      };

    });
  }

  onSubmit() {
    const { checkValue, userDefinedList } = this.state;
    const { handleAddCallback, closeModal } = this.props;
    const newArray = userDefinedList.filter((item) => { return checkValue.includes(item.user_defined_id); });
    closeModal();
    handleAddCallback(newArray);
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return (
      `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`
    );
  }

  openTooltipWithKeyName(id) {
    this.timeout = setTimeout(() => {
      this.setState({ tooltipWithKeyName: id });
    }, 250);
  }

  closeTooltipWithKeyName() {
    this.setState({ tooltipWithKeyName: '' });
    clearTimeout(this.timeout);
  }

  openTooltipWithDetailValue(id) {
    this.timeout = setTimeout(() => {
      this.setState({ tooltipWithDetailValue: id });
    }, 250);
  }

  closeTooltipWithDetailValue() {
    this.setState({ tooltipWithDetailValue: '' });
    clearTimeout(this.timeout);
  }

  closeModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        userDefinedList: [],
      },
      () => {
        this.searchCustomerCompanyDefinedResults();
      }
    );
  }

  searchCustomerCompanyDefinedResults(excludeIds) {
    const { searchKeyword } = this.state;

    api
      .searchCustomerCompanyDefinedResults({
        search: searchKeyword || '',
        exclude_ids: excludeIds || [],
      })
      .then((response) => {
        const newData = response.response;
        this.setState({
          userDefinedList: newData,
          //error: null,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          //error: translate('modal.error.error_load'),
        });
      });
  }

  renderTypeValue(rowData) {
    const { translate } = this.props;
    if (rowData.type === 'component') {
      if (rowData.key2 === null || rowData.key2 === '') {
        return translate('list.title.component');
      }
      return translate('list.title.component_version');
    }
    if (rowData.type === 'hash') {
      return translate('settings.list.type_hash');
    }
  }

  renderKeyName(rowData) {
    const { translate } = this.props;
    const { tooltipWithKeyName, copied } = this.state;
    if (rowData.type === 'hash') {
      return (
        <Popup
          trigger={(
            <span className="tooltip-icon">
              {rowData.key1}
            </span>
          )}
          position="bottom left"
          hoverable
          hideOnScroll
          open={tooltipWithKeyName === rowData.user_defined_id}
          onOpen={() => {
            return this.openTooltipWithKeyName(rowData.user_defined_id);
          }}
          onClose={this.closeTooltipWithKeyName}
        >
          <Form className="popup_list">
            <Form.Field style={{ width: '470px' }}>
              <label>
                {translate('settings.list.sha256')}
                <Icon
                  className={`copy_value ${copied ? 'copied' : ''}`}
                  name="copy outline"
                  onClick={() => { return this.handleCopy(rowData.key1); }}
                  aria-label="Copy to clipboard"
                />
                {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{translate('settings.list.copied')}</span>}
              </label>
              <Form.Input value={rowData.key1} readOnly />
            </Form.Field>
          </Form>
        </Popup>
      );
    }
    return (
      <Popup
        trigger={(
          <span className="tooltip-icon">
            {rowData.key1}
          </span>
        )}
        position="bottom left"
        hoverable
        hideOnScroll
        open={tooltipWithKeyName === rowData.user_defined_id}
        onOpen={() => {
          return this.openTooltipWithKeyName(rowData.user_defined_id);
        }}
        onClose={this.closeTooltipWithKeyName}
      >
        <Form className="popup_list">
          <Form.Field style={{ width: '150px' }}>
            <label>
              {translate('list.title.component')}
              <Icon
                className={`copy_value ${copied ? 'copied' : ''}`}
                name="copy outline"
                onClick={() => { return this.handleCopy(rowData.key1); }}
                aria-label="Copy to clipboard"
              />
              {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{translate('settings.list.copied')}</span>}
            </label>
            <Form.Input value={rowData.key1} readOnly />
          </Form.Field>
        </Form>
      </Popup>
    );
  }

  renderKeyNameDetail(rowData) {
    const { translate } = this.props;
    const { tooltipWithDetailValue, copied } = this.state;

    if (rowData.type === 'hash') {
      return (
        <Popup
          trigger={(
            <span className="tooltip-icon">
              {this.formatBytes(rowData.key2)}
            </span>
          )}
          position="bottom left"
          hoverable
          hideOnScroll
          open={tooltipWithDetailValue === rowData.user_defined_id}
          onOpen={() => {
            return this.openTooltipWithDetailValue(rowData.user_defined_id);
          }}
          onClose={this.closeTooltipWithDetailValue}
        >
          <Form className="popup_list">
            <Form.Field style={{ width: '150px' }}>
              <label>
                {translate('settings.list.size')}
                <Icon
                  className={`copy_value ${copied ? 'copied' : ''}`}
                  name="copy outline"
                  onClick={() => { return this.handleCopy(rowData.key2); }}
                  aria-label="Copy to clipboard"
                />
                {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{translate('settings.list.copied')}</span>}
              </label>
              <Form.Input value={this.formatBytes(rowData.key2)} readOnly />
            </Form.Field>
          </Form>
        </Popup>
      );
    }
    return (
      <Popup
        trigger={(
          <span className="tooltip-icon">
            {rowData.key2}
          </span>
        )}
        position="bottom left"
        hoverable
        hideOnScroll
        open={tooltipWithDetailValue === rowData.user_defined_id}
        onOpen={() => {
          return this.openTooltipWithDetailValue(rowData.user_defined_id);
        }}
        onClose={this.closeTooltipWithDetailValue}
      >
        <Form className="popup_list">
          <Form.Field style={{ width: '150px' }}>
            <label>
              {translate('list.title.component_version')}
              <Icon
                className={`copy_value ${copied ? 'copied' : ''}`}
                name="copy outline"
                onClick={() => { return this.handleCopy(rowData.key2); }}
                aria-label="Copy to clipboard"
              />
              {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{translate('settings.list.copied')}</span>}
            </label>
            <Form.Input value={rowData.key2} readOnly />
          </Form.Field>
        </Form>
      </Popup>
    );
  }

  render() {
    const { translate, isOpenMUD } = this.props;
    const {
      userDefinedList,
      searchKeyword,
      isCheckAll,
      checkValue,
      //error,
      errSearch,
    } = this.state;

    return (
      <Modal open={isOpenMUD} onClose={this.closeModal}>
        <div className="setting_popup_wrap">
          <div className="setting_popup applying_policy">
            <div className="popup_scroll">
              <div className="setting_popup_header">
                <h2 className="popup_name">
                  {translate('modal.title.assigned_user_defined')}
                </h2>
                <a
                  className="popup_close_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <div className="setting_popup_contnets">
                <div className="setting_popup_content_wrap">
                  <div className="setting_popup_content">
                    <div className="search_box">
                      <span className="search_icon">
                        <img src={searchIcon} alt="" />
                      </span>
                      <input
                        type="text"
                        value={searchKeyword}
                        placeholder={translate('contents_header.place_holder.scan_file_and_component')}
                        onChange={this.handleSearchDefinedResultChange}
                        onKeyPress={this.handleSearchKeyPress}
                      />
                      <a
                        className="reset_icon"
                        onClick={this.clearSearch}
                        onKeyUp={this.clearSearch}
                      >
                        x
                      </a>
                      {errSearch && (
                        <Label basic color="red" pointing>
                          {translate('contents_header.message.least_two_required_to_search')}
                        </Label>
                      )}
                    </div>
                  </div>
                  <div className="setting_popup_content">
                    <div
                      className="table_wrap table_type_3 user_defined"
                    >
                      <Scrollbars
                        renderTrackHorizontal={() => {
                          return <div />;
                        }}
                        renderThumbHorizontal={() => {
                          return <div />;
                        }}
                      >
                        <table className="table table_type_3" style={{ tableLayout: 'fixed' }}>
                          <colgroup>
                            <col style={{ width: '36px' }} />
                            <col style={{ width: '180px' }} />
                            <col style={{ width: '' }} />
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '20%' }} />
                          </colgroup>
                          <thead>
                            <tr>
                              <th>
                                <Checkbox
                                  checked={isCheckAll}
                                  onChange={this.handleCheckAllChange}
                                />
                              </th>
                              <th>{translate('settings.list.defined_target')}</th>
                              <th>{translate('settings.list.type')}</th>
                              <th>{translate('settings.list.key_name')}</th>
                              <th>{translate('settings.list.value_detail')}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {userDefinedList.length !== 0
                              ? userDefinedList.map((item) => {
                                return (
                                  <tr key={uuidv4()}>
                                    <td className="text">
                                      <Checkbox
                                        value={item.user_defined_id}
                                        checked={checkValue.indexOf(item.user_defined_id) > -1}
                                        onChange={this.handleCheckChange}
                                      />
                                    </td>
                                    <td className="text">
                                      {item.target}
                                    </td>
                                    <td className="text">
                                      {this.renderTypeValue(item)}
                                    </td>
                                    <td>
                                      {this.renderKeyName(item)}
                                    </td>
                                    <td>
                                      {this.renderKeyNameDetail(item)}
                                    </td>
                                  </tr>
                                );
                              })
                              : null}
                          </tbody>
                        </table>
                      </Scrollbars>
                    </div>
                  </div>
                </div>
                <div className="setting_popup_button_wrap">
                  <a
                    className="button cencel_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {translate('modal.button.cancel')}
                  </a>
                  <a
                    className="button save_button"
                    onClick={this.onSubmit}
                    onKeyUp={this.onSubmit}
                  >
                    {translate('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal open={this.state.isOpen} onClose={this.closeErrorModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <p className="text">{translate('modal.message.select_one_user')}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeErrorModal}
                    onKeyUp={this.closeErrorModal}
                  >
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default AddUserDefinedModal;
